// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"8790ccda","274":"221bda99","419":"ddb27f33","774":"5d4d2d6f","787":"294bbf47","858":"d3d3964a","942":"7ca4b039","979":"2e93db24"}[chunkId] + ".chunk.js";
};